import { useFragment, graphql } from 'react-relay';
import {
    useItemTranslations,
    INTERFACE_STATE,
} from '../PdpSharedOriginalLanguageProvider/PdpSharedOriginalLanguageProvider.tsx';
import { getAttributeInfo } from '../helpers/getAttributeInfo.ts';

// types
import { type useCustomizationOptions_item$key as Item } from './__generated__/useCustomizationOptions_item.graphql.ts';

const itemFragment = graphql`
    fragment useCustomizationOptions_item on Item {
        attributes {
            ...getAttributeInfo_itemAttributes
        }
    }
`;

export const useCustomizationOptions = ({
    item: itemRef,
}: {
    item: Item;
}): {
    customizationOptions: string | null | undefined;
    isResizable: boolean;
} => {
    const item = useFragment(itemFragment, itemRef);
    const [state] = useItemTranslations();
    const itemAttributes =
        state?.interfaceState === INTERFACE_STATE.SHOW_ORIGINAL
            ? state?.data?.viewer?.item?.attributes
            : item?.attributes;
    return getAttributeInfo(itemAttributes);
};
